export default __webpack_public_path__ + "static/char-thumb-54-c89d564d74d5da1280691b44a7973f63.png";